export function notEmptyString(value: string | null | undefined): value is string {
  return !!value
}

export function compareIgnoreCase(a: string, b: string): number {
  return a.toLocaleString().localeCompare(b.toLowerCase())
}

export function toLowerCase(value: string): string {
  return value.toLowerCase()
}

export function capitalize(value: string): string {
  if (!value) return ''
  const [first] = value
  if (!first) return ''
  return first.toUpperCase() + value.slice(1).toLowerCase()
}

export function isLetter(text: string | undefined) {
  return /\p{Letter}/gu.test(text || '')
}
